import { Column } from "@/components/common/Table";
import { TruncatedTableCell } from "@/components/common/TruncatedTableCell";

// Define table columns with flexible widths
export const columns: Column<AdtAlert>[] = [
  {
    key: "eventdate",
    label: "Event Date",
    isSortable: false,
    cellClassName: "w-[25%] max-w-[110px]",
    headerClassName: "w-[25%] max-w-[110px]",
    render: (row) => (
      <TruncatedTableCell
        content={row.eventdate || "-"}
        className='text-grey-800 dark:text-white'
      />
    ),
  },
  {
    key: "eventType",
    label: "Event Type",
    cellClassName: "w-[30%] max-w-[120px]",
    headerClassName: "w-[30%] max-w-[120px]",
    render: (row) => (
      <TruncatedTableCell
        content={row.eventType || "-"}
        className='text-grey-800 dark:text-white'
      />
    ),
  },
  {
    key: "facility",
    label: "Facility",
    isSortable: false,
    cellClassName: "w-[160px] max-w-[160px] ",
    headerClassName: "w-[160px] max-w-[160px] ",
    render: (row) => (
      <TruncatedTableCell
        content={row.facility || "-"}
        className='text-grey-800 dark:text-white'
      />
    ),
  },
];
